export default __webpack_public_path__ + "static/media/cripple2.c8468e5b.png";